export const actionMap = {}

export const defaultState = {
    data: undefined,
    types: undefined,
    isLoading: false,
    isLoadingTypes: false
}

export default (reduxState = defaultState, action) => {
    if (action !== undefined && actionMap[action.type]) {
        return actionMap[action.type](reduxState, action)
    }
    return reduxState;
}



// WEBPACK FOOTER //
// ./src/screens/weather/reducers/index.js